import Rand from 'rand-seed';

// A pure random for the site to use, don't use it if you need repeatability (make your own!)
// Linters and react don't like Math.random() as its impure, so this is our solution
export const Random = new Rand('WeLoveEedi!');
